<template>
  <modal-error
    v-if="currentError"
    v-bind="currentError"
    @done="$store.commit('error/dequeError')"
  />
</template>

<script>
import { mapState } from 'vuex'
import ModalError from '~/components/modal/modal-error.vue'

export default {
  name: 'ModalErrorController',
  components: {
    ModalError,
  },
  computed: mapState({
    currentError: state => state.error.queue[0],
  }),
}
</script>
